import { render, staticRenderFns } from "./ReportsDashboard.vue?vue&type=template&id=4eb3e224&scoped=true"
import script from "./ReportsDashboard.vue?vue&type=script&lang=js"
export * from "./ReportsDashboard.vue?vue&type=script&lang=js"
import style0 from "./ReportsDashboard.vue?vue&type=style&index=0&id=4eb3e224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb3e224",
  null
  
)

export default component.exports